import * as React from 'react';

export interface SwitchProps {
    label?:string;
    checked?: boolean;
    size?: 'large' | 'mini' | 'default';
    onChange?: (e:boolean) => void;
}


export interface SwitchState {
    checked: boolean;
}

export default class Switch extends React.Component<SwitchProps, SwitchState> {
  constructor(props: SwitchProps) {
    super(props);

    this.state = {
        checked: this.props.checked || false
    }
  }

  handleSwitch = () => {
    this.setState({checked: !this.state.checked}, () => {
        if(this.props.onChange)
            this.props.onChange(this.state.checked);
    })
  }

  public componentWillReceiveProps(nextProps: SwitchProps){
    if(nextProps.checked != this.props.checked && nextProps.checked){
      this.setState({checked: nextProps.checked});
    }
  }

  public render() {
    return (
      <div className={'switch ' }>
        {this.props.label && <label className='switch-label'>{this.props.label}</label>}

        <div className={'switch-container '  + (this.state.checked? 'checked': '')} onClick={this.handleSwitch}>
            <div className={'switch-indicator ' + (this.state.checked? 'checked': '')}>

            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/switch.tsx